import { mapEnumToOptions } from '@abp/ng.core';

export enum CustomerRegistrationSource {
  qrcode = 0,
  web = 1,
}

export const customerRegistrationSourceOptions = mapEnumToOptions(CustomerRegistrationSource);
